const FALLBACK_CURRENCY_CODES = ['USD', 'EUR', 'GBP', 'TND'] as const

const getSupportedCurrencyCodes = (): string[] => {
  const supportedValuesOf = (Intl as any).supportedValuesOf as
    | ((type: string) => string[])
    | undefined

  if (typeof supportedValuesOf !== 'function') {
    return [...FALLBACK_CURRENCY_CODES]
  }

  try {
    return supportedValuesOf('currency')
      .map((code) => code.toUpperCase())
      .sort((a, b) => a.localeCompare(b))
  } catch {
    return [...FALLBACK_CURRENCY_CODES]
  }
}

export const CURRENCY_CODES = getSupportedCurrencyCodes()

export const getCurrencyLabel = (currencyCode: string, locale = 'en'): string => {
  try {
    const displayNames = new Intl.DisplayNames([locale], { type: 'currency' })
    const label = displayNames.of(currencyCode.toUpperCase())
    return label ? `${currencyCode.toUpperCase()} - ${label}` : currencyCode.toUpperCase()
  } catch {
    return currencyCode.toUpperCase()
  }
}
